import { render } from "./EndNode.vue?vue&type=template&id=5b316744&ts=true"
import script from "./EndNode.vue?vue&type=script&lang=ts&setup=true"
export * from "./EndNode.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/connect-flow/components/flow/nodes/EndNode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b316744"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b316744', __exports__)) {
    api.reload('5b316744', __exports__)
  }
  
  module.hot.accept("./EndNode.vue?vue&type=template&id=5b316744&ts=true", () => {
    api.rerender('5b316744', render)
  })

}


export default __exports__